import { useOptimizedQuery } from './useOptimizedQuery';
import { supabase } from '@/integrations/supabase/client';
import { logger } from '@/lib/logger';

export const useSOLUsers = () => {
  return useOptimizedQuery({
    queryKey: ['sol-users'],
    queryFn: async () => {
      try {
        const { data, error } = await supabase
          .rpc('get_sol_users');
        
        if (error) throw error;
        
        return (data || []).map(user => ({
          id: user.id,
          full_name: user.full_name,
          email: user.email,
          avatar_url: user.avatar_url,
          name: user.full_name || user.email || 'Unknown',
        }));
      } catch (error) {
        logger.error('[useSOLUsers] Error fetching SOL users:', error);
        return [];
      }
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
  });
};
